// https://github.com/kubernetes/community/tree/master/icons
// https://docs.google.com/presentation/d/15h_MHjR2fzXIiGZniUdHok_FP07u1L8MAX5cN1r0j4U/edit

export const resources = new Map<string, string>([
    ['ClusterRole', 'c-role'],
    ['ConfigMap', 'cm'],
    ['ClusterRoleBinding', 'crb'],
    ['CustomResourceDefinition', 'crd'],
    ['CronJob', 'cronjob'],
    ['Deployment', 'deploy'],
    ['DaemonSet', 'ds'],
    ['Endpoint', 'ep'],
    ['Endpoints', 'ep'],
    ['Group', 'group'],
    ['HorizontalPodAutoscaler', 'hpa'],
    ['Ingress', 'ing'],
    ['Job', 'job'],
    ['LimitRange', 'limits'],
    ['NetworkPolicy', 'netpol'],
    ['Namespace', 'ns'],
    ['Pod', 'pod'],
    ['PodSecurityPolicy', 'psp'],
    ['PersistentVolume', 'pv'],
    ['PersistentVolumeClaim', 'pvc'],
    ['Quote', 'quota'],
    ['RoleBinding', 'rb'],
    ['Role', 'role'],
    ['ReplicaSet', 'rs'],
    ['ServiceAccount', 'sa'],
    ['StorageClass', 'sc'],
    ['Secret', 'secret'],
    ['StatefulSet', 'sts'],
    ['Service', 'svc'],
    ['User', 'user'],
    ['Volume', 'vol']
]);
